export const faqs: { q: string; a: string }[] = [
  {
    q: 'Do I need an electrician or any wiring?',
    a: 'No. The M1 PRO is fully wireless and rechargeable. There is no wiring to the pool, no electrician and no draining. Install the magnetic base once, snap the light on and you are done.',
  },
  {
    q: 'How do I charge it?',
    a: 'Lift the light off its magnetic base — the base stays exactly where it is — and charge it over USB-C. The port sits behind a blue protective cover on the rear. Snap it back onto the same base when it is ready.',
  },
  {
    q: 'How long does a charge last?',
    a: 'Up to 70 hours per charge. With the 8-Light Signature System — 4 installed, 4 charged and ready — you get about a week of pool lighting without stopping to recharge: swap in the charged set and keep the pool lit while the others charge.',
  },
  {
    q: 'Why buy a system with backup lights?',
    a: 'One set lights the pool while the other charges. When it is time to recharge, swap the sets onto the same magnetic bases in seconds — no remounting, no re-measuring, no dark nights. Larger systems also lower your price per light and include a Limited Lifetime Warranty.',
  },
  {
    q: 'How many lights do I need?',
    a: 'Choose how many positions you want to light, then double it if you want a charged backup set. Use the “How many lighting positions” calculator above — it recommends the matching system. Most pools start with the 8-Light Signature System: 4 installed, 4 ready.',
  },
  {
    q: 'What surfaces does the magnetic base mount to?',
    a: 'Every base comes with waterproof mounting sealant. Clean and dry the spot, apply the sealant, press the base in place and let it cure for 12 hours before snapping on the light. After that the base stays put — underwater — and you only ever swap the lights. Not sure about your pool or spa finish? Contact support and we will help you pick the best position.',
  },
  {
    q: 'Can I control the colors?',
    a: 'Yes. Every M1 PRO offers 16 colors and dynamic lighting modes, and a remote control is included (it uses 2 AAA batteries, not included).',
  },
  {
    q: 'What warranty do I get?',
    a: 'Systems of 4, 6, 8, 12 and 24 lights include a Limited Lifetime Warranty. Single lights and the 2-light Duo System include a 1-Year Limited Warranty. See the Warranty page for full terms.',
  },
  {
    q: 'How much is shipping?',
    a: 'Free. Every U.S. order ships free via USPS — no minimum — tracked and insured, with a tracking number emailed when it ships. Need it faster? Choose 2-day USPS shipping at checkout for an additional fee.',
  },
  {
    q: 'Can I return it?',
    a: 'Yes. You have 30 days from delivery to request a return. See our Return & Refund Policy for the full conditions.',
  },
  {
    q: 'Can I use the M1 PRO in saltwater, on docks or on boats?',
    a: 'Contact our support team before using the M1 PRO in saltwater or marine environments so we can advise on care and placement for your application.',
  },
];
